/** Fixed-position hover preview boards (games, courses, explorer). */

/** Default hover popup board width on desktop. */
export const HOVER_PREVIEW_BOARD_WIDTH = 280;

/** Hover popup boards on wide desktop (1920px+). */
export const HOVER_PREVIEW_BOARD_WIDTH_WIDE = 440;

/** Hover popup boards on ultra-wide / 4K (2560px+). */
export const HOVER_PREVIEW_BOARD_WIDTH_ULTRA = 720;

/** Vertical inset when clamping the popup within the viewport. */
export const HOVER_PREVIEW_VIEWPORT_INSET_PX = 16;

export type HoverPreviewBoardViewport = {
  isWideDesktop: boolean;
  isUltraWide: boolean;
  viewportHeight: number;
};

/** Resolve hover popup board width for the current viewport band, capped by height. */
export const resolveHoverPreviewBoardWidth = ({
  isWideDesktop,
  isUltraWide,
  viewportHeight,
}: HoverPreviewBoardViewport): number => {
  const bandWidth = isUltraWide
    ? HOVER_PREVIEW_BOARD_WIDTH_ULTRA
    : isWideDesktop
      ? HOVER_PREVIEW_BOARD_WIDTH_WIDE
      : HOVER_PREVIEW_BOARD_WIDTH;
  const heightCap = Math.max(
    HOVER_PREVIEW_BOARD_WIDTH,
    viewportHeight - HOVER_PREVIEW_VIEWPORT_INSET_PX * 2,
  );
  return Math.min(bandWidth, heightCap);
};
